import ExploreTableZeroCase from './ExploreTableZeroCase';

export default ExploreTableZeroCase;
